<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>对账单列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="l-list">
            尖时
            <el-input
              placeholder="尖时电价"
              :disabled="fx_login_companyType == 1"
              v-model="topPrice"
              style="width: 100px"
            />
            峰时
            <el-input
              placeholder="峰时电价"
              :disabled="fx_login_companyType == 1"
              v-model="peakPrice"
              style="width: 100px"
            />
            平时
            <el-input
              placeholder="平时电价"
              :disabled="fx_login_companyType == 1"
              v-model="flatPrice"
              style="width: 100px"
            />
            谷时
            <el-input
              placeholder="谷时电价"
              :disabled="fx_login_companyType == 1"
              v-model="valleyPrice"
              style="width: 100px"
            />
            高尖时
            <el-input
              placeholder="高尖时电价"
              :disabled="fx_login_companyType == 1"
              v-model="highTopPrice"
              style="width: 100px"
            />
            <el-button
              type="primary"
              @click="addLinkUrl"
              v-if="fx_login_companyType == 0"
              >修改电价</el-button
            >
            <el-button type="primary" v-if="state != 1" @click="okLinkUrl"
              >确认对账单</el-button
            >
          </div>
          <div class="r-list">
            <div class="search-box"></div>
          </div>
        </div>
        <div class="list-box">
          <div class="l-list">
            <el-select v-model="device" filterable placeholder="请选择设备">
              <el-option
                v-for="item in deviceList"
                :key="item.id"
                :label="item.cabinetName"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              slot="append"
              icon="el-icon-search"
              @click="initData"
            ></el-button>
            <el-button type="primary" @click="fileExport">导出对账单</el-button>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="客户名称" width="80">
              <template slot-scope="scope">
                <h4>{{ scope.row.companyName }}</h4>
              </template>
            </el-table-column>
            <el-table-column
              prop="cabinetCode"
              label="设备编号"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="cabinetName"
              label="设备标签"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="date"
              label="日期"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="valleyChargePower"
              label="谷时充电量"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="valleyDischargePower"
              label="谷时放电量"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="flatChargePower"
              label="平时充电量"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="flatDischargePower"
              label="平时放电量"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="peakChargePower"
              label="峰时充电量"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="peakDischargePower"
              label="峰时放电量"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="topChargePower"
              label="尖时充电量"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="topDischargePower"
              label="尖时放电量"
              width="90"
            ></el-table-column>
            <el-table-column
              prop="highTopChargePower"
              label="高尖时充电量"
              width="110"
            ></el-table-column>
            <el-table-column
              prop="highTopDischargePower"
              label="高尖时放电量"
              width="110"
            ></el-table-column>
            <el-table-column
              prop="totalChargePower"
              label="充电电量"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="totalExpenditure"
              label="成本（元）"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="totalDischargePower"
              label="放电电量"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="totalIncome"
              label="收入（元）"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="totalProfit"
              label="收益（元）"
            ></el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";
import fileDownload from "js-file-download";
export default {
  data() {
    return {
      deviceList: [],
      topPrice: 0,
      peakPrice: 0,
      flatPrice: 0,
      valleyPrice: 0,
      highTopPrice: 0,
      device: "",
      state: 0,
      loading: false,
      keyword: "",
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      fx_login_companyType: 0,
    };
  },
  mounted() {
    const _this = this;
    _this.fx_login_companyType = localStorage.getItem("fx_login_companyType");
    // 获取公司设备
    AxiosAjax({
      url: "/cabinet/cabinet/search?companyId=" + _this.$route.query.id,
      success: function (res) {
        _this.deviceList = res.data.data;
      },
    });
  },
  methods: {
    fileExport() {
      let _this = this;
      let sendUrl = "/cabinet/chargeStatement/dailyStatsExport";
      sendUrl += "?index=1";
      sendUrl += "&size=9999999";
      sendUrl += "&companyId=" + _this.$route.query.id;
      sendUrl += "&gmtCreate=" + _this.$route.query.gmtCreate;
      if (_this.device) {
        sendUrl += "&cabinetId=" + _this.device;
      }
      _this.$axios
        .get("https://ms.fuxinsz.com" + sendUrl, {
          responseType: "blob",
          headers: {
            Authorization: localStorage.getItem("fx_client_access_token"),
          },
        })
        .then((res) => {
          fileDownload(res.data, "对账单.xlsx");
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/chargeStatement/search";

      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;
      sendUrl += "&companyId=" + _this.$route.query.id;
      sendUrl += "&gmtCreate=" + _this.$route.query.gmtCreate;
      if (_this.device) {
        sendUrl += "&cabinetId=" + _this.device;
      }
      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.dtoPageResult.content;
          _this.totalCount = res.data.data.dtoPageResult.total;
          _this.pageIndex = res.data.data.dtoPageResult.index;
          _this.topPrice = res.data.data.topPrice || 0;
          _this.peakPrice = res.data.data.peakPrice || 0;
          _this.flatPrice = res.data.data.flatPrice || 0;
          _this.valleyPrice = res.data.data.valleyPrice || 0;
          _this.highTopPrice = res.data.data.highTopPrice || 0;
        },
        error: function (err) {
          _this.listData = null;
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    addLinkUrl() {
      const _this = this;
      const params = {
        companyId: _this.$route.query.id,
        cabinetId: _this.device || "",
        gmtCreate: _this.$route.query.gmtCreate,
        topPrice: _this.topPrice,
        peakPrice: _this.peakPrice,
        flatPrice: _this.flatPrice,
        valleyPrice: _this.valleyPrice,
        highTopPrice: _this.highTopPrice,
        // size: _this.pageIndex,
        // index: _this.pageIndex
      };
      AxiosAjax({
        method: "post",
        url: "/cabinet/chargeStatement/updateElectricityPrice",
        data: params,
        loading: true,
        successMsg: "修改客户成功",
        success: function (res) {
          _this.initData();
        },
      });
    },
    okLinkUrl() {
      const _this = this;
      const params = {
        companyId: _this.$route.query.id,
        gmtCreate: _this.$route.query.gmtCreate,
      };
      AxiosAjax({
        method: "post",
        url: "/cabinet/chargeStatement/affirmStatement",
        data: params,
        loading: true,
        successMsg: "修改客户成功",
        success: function (res) {
          _this.initData();
        },
      });
    },
    //跳转链接
    linkUrl: function (url) {
      this.$router.push({ name: "ReconciliationEdit", query: { id: url } });
    },
    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
      //console.log('当前页: ${val}');
    },
  },
  created: function () {
    //加载数据
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Reconciliation/ReconciliationEdit.vue